//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'icon-handbooks',
};
